import { ShippableContainerItemFragment, WasteClassification } from "generated-graphql/graphql";

export type ShippableContainerStreamGroup = {
  /** Empty for uncharacterized containers, which have no stream to key on. */
  streamId: string;
  streamName: string | null;
  classification: WasteClassification | null;
  containers: ShippableContainerItemFragment[];
};

/**
 * Containers grouped by waste stream, alphabetically, uncharacterized last.
 *
 * The stream is what the vendor manifests and what the contents grid groups by,
 * so every picker orders itself the same way — a flat list makes the reader
 * rebuild the grouping themselves to answer "is this whole stream going out?".
 *
 * Lives apart from the row components it feeds so the module holding them stays
 * components-only, which is what Fast Refresh needs to reload a picker without
 * losing the selection the user has built up in it.
 */
export function groupContainersByStream(
  containers: ShippableContainerItemFragment[]
): ShippableContainerStreamGroup[] {
  const groups = new Map<string, ShippableContainerStreamGroup>();
  for (const container of containers) {
    const streamId = container.wasteStream?.id ?? "";
    const group = groups.get(streamId) ?? {
      streamId,
      streamName: container.wasteStream?.name ?? null,
      classification: container.wasteStream?.classification ?? null,
      containers: [],
    };
    group.containers.push(container);
    groups.set(streamId, group);
  }
  // U+FFFF sorts after any real name, which puts the unnamed group last.
  return [...groups.values()].sort((a, b) =>
    (a.streamName ?? "￿").localeCompare(b.streamName ?? "￿")
  );
}
